"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tabsHeader = require("./tabs-header.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TabsHeader = ({
  align = "left",
  children,
  position = "top",
  role,
  extendedLine,
  alternateStyling,
  noRightBorder = false,
  isInSidebar = false
}) => {
  return /*#__PURE__*/_react.default.createElement(_tabsHeader.StyledTabsHeaderWrapper, {
    isInSidebar: isInSidebar,
    position: position
  }, /*#__PURE__*/_react.default.createElement(_tabsHeader.StyledTabsHeaderList, {
    align: align,
    position: position,
    role: role,
    extendedLine: extendedLine,
    alternateStyling: alternateStyling,
    noRightBorder: noRightBorder,
    isInSidebar: isInSidebar
  }, children));
};

TabsHeader.propTypes = {
  align: _propTypes.default.oneOf(["left", "right"]),
  children: _propTypes.default.node.isRequired,
  position: _propTypes.default.oneOf(["top", "left"]),
  role: _propTypes.default.string,
  extendedLine: _propTypes.default.bool,
  alternateStyling: _propTypes.default.bool,
  noRightBorder: _propTypes.default.bool,
  isInSidebar: _propTypes.default.bool
};
var _default = TabsHeader;
exports.default = _default;